import React from 'react';
import RomanianPackage from '../languages/RomanianPackage';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {submitInsertForm} from '../actionCreators/submitInsertForm';
import { getOptions } from '../actionCreators/getOptions';
import {getDomains} from '../actionCreators/getDomains';
import {getTypes} from '../actionCreators/getTypes';
import {toggleForm} from '../actionCreators/toggleForm';
import {selectOption} from '../actionCreators/selectOption';
import PHPURL from '../reducers/ReducerPHPURL';
import FieldBuilder from './FieldBuilder';

class FormBuilder extends React.Component {

    constructor(props) {
        
        super(props);

        this.handleToggle = this.handleToggle.bind(this);
        this.submitData = this.submitData.bind(this);

    }

    componentDidMount() {

        if (this.props.view.formOptions) {
            this.props.getOptions(this.props.view.formOptions);
        }
        
        this.props.getDomains();
        this.props.getTypes();

    }

    handleToggle() {

        this.props.toggleForm(this.props.hideForm);
        
    }

    submitData(e) {

        e.preventDefault();

        this.props.formData.table = this.props.view.insertTable;

        let phpPath = PHPURL.baseURL+PHPURL.insertData;

        let formData = new FormData();
        Object.keys(this.props.formData.formData).forEach(key => {
            formData.append(key, this.props.formData.formData[key]);
        });
        formData.append('table', this.props.formData.table);
        
        this.props.fields.forEach(field => {
            
            if(field.Type === 'hidden') {
                formData.append(field.Field, this.props[field.Value])
            }
        });

        if (this.props.formFile) {
            formData.append('pdf', this.props.formFile, this.props.formFile.name);
        };

        this.props.submitInsertForm(phpPath, formData, this.props.view);
    }

    render () {

        return (
            <div>
                <button 
                    onClick = {this.handleToggle}
                    hidden = {this.props.view.hideAddButton}
                >
                    { RomanianPackage.ADD }
                </button>
                {(() => {
                    if(this.props.view.defaultName === "FUTURE_ACTIVITIES") {
                        if(this.props.activityType === "Peste noapte"){
                            return (
                                <p class="infotext">Activitatile de tip 'Peste noapte' sunt cele care incep intr-o zi si se termina a doua zi, fara intrerupere.</p>
                            )
                        }
                        else if (this.props.activityType === "Mai multe zile") {
                            return (
                                <p class="infotext">
                                    Activitatile de tip 'Mai multe zile' sunt cele care au program identic si aceiasi participanti pe durata a mai multe zile (ex tabara, curs).
                                    Orele de voluntariat pentru aceast tip de activitate se calculeaza automat ca numar de ore pe zi (diferenta intre ora final si ora inceput) 
                                    inmultit cu numar de zile (diferenta intre data sfarsit si data inceput).
                                </p>
                            )
                        }
                    }
                })()}
                <form
                    hidden = { this.props.hideForm }
                    onSubmit = {this.submitData}
                    id = 'insertForm'
                > 
                    {this.props.fields.map(
                        function(field, index){
                            return <FieldBuilder field = { field } index = { index } key = { index } />
                        }
                    )}
                    <input type = "submit" value = {RomanianPackage.SUBMIT} />
                </form>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        fields: state.activeOption.formLabels,
        view: state.activeOption,
        formData: state.formData,
        formFile: state.formFile,
        hideForm: state.hideForm,
        userId: state.userId,
        activityType: state.activityType
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        submitInsertForm: submitInsertForm,
        getOptions: getOptions,
        toggleForm: toggleForm,
        getDomains: getDomains,
        getTypes: getTypes,
        selectOption: selectOption
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(FormBuilder);


// WEBPACK FOOTER //
// ./src/formBuilder/FormBuilder.js